import { Controller } from "@hotwired/stimulus";
import Cookies from "js-cookie";

export default class extends Controller {
  static targets = ["sidebar"];
  static classes = ["reduced", "expandedOnHover"];

  toggleCollapse() {
    this.element.classList.toggle(this.reducedClass);
    if (this.hasExpandedOnHoverClass) {
      this.element.classList.remove(this.expandedOnHoverClass);
    }
    this._saveState();
  }

  expandHover() {
    if (this._isSidebarReduced()) {
      this.element.classList.add(this.expandedOnHoverClass);
      this.element.addEventListener("transitionend", () => this.element.classList.add("expanded"), { once: true });
    }
  }
  reduceHover() {
    this.element.classList.remove(this.expandedOnHoverClass);
    this.element.addEventListener("transitionend", () => this.element.classList.remove("expanded"), { once: true });
  }

  expandOnTouch() {
    if (this._isSidebarReduced() && this._isTouchInSidebar()) {
      event.preventDefault();
      this.toggleCollapse();
    }
  }

  _isTouchInSidebar() {
    return this.sidebarTarget.contains(event.targetTouches[0].target);
  }

  _isSidebarReduced() {
    return this.element.classList.contains(this.reducedClass);
  }

  _saveState() {
    const key = this.element.dataset.sidebarCollapsedCookiesKey;
    if (this._isSidebarReduced()) {
      Cookies.set(key, true);
    } else {
      Cookies.remove(key);
    }
  }
}
